(function () {

  const body = document.querySelector('html[data-scheme]');

  if (!body) return;

  const cscoDarkMode = {
    init() {
      this.initMode();

      window.matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', () => {
          this.initMode();
        });

      const toggleBtns = document.querySelectorAll('.header__toggle-scheme');

      toggleBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          if ('auto' === body.getAttribute('data-scheme')) {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
              this.changeScheme('light', true);
            } else {
              this.changeScheme('dark', true);
            }
          } else {
            if ('dark' === body.getAttribute('data-scheme')) {
              this.changeScheme('light', true);
            } else {
              this.changeScheme('dark', true);
            }
          }
        });
      });
    },

    initMode() {
      let siteScheme = false;

      switch (body.dataset.schemeDefault) {
        case 'dark':
          siteScheme = 'dark';
          break;
        case 'light':
          siteScheme = 'light';
          break;
        default:
          siteScheme = 'auto';
      }

      const saved = localStorage.getItem('_color_schema');

      if (saved === 'light' || saved === 'dark') {
        siteScheme = saved;
      }

      this.changeScheme(siteScheme, false);
    },

    changeScheme(siteScheme, save) {
      body.classList.add('scheme-toggled');

      body.setAttribute('data-scheme', siteScheme);

      if (save) {
        localStorage.setItem('_color_schema', siteScheme);
      }

      setTimeout(() => {
        body.classList.remove('scheme-toggled');
      }, 100);
    }
  };

  cscoDarkMode.init();

})();